import {observer} from "mobx-react";
import * as React from "react";
import {StepData} from "components/chart/StepData";
import {LineAndCandleData} from "components/chart/LineAndCandleData";
import {AvgMinMax} from "components/chart/AvgMinMax";
import {LineAndCandleChart} from "components/chart/LineAndCandleChart";

interface IWeeklyLineAndCandleChart {
  post: any;
  feedItems: Array<any>;
  stepId: string;
}

@observer
class WeeklyLineAndCandleChart extends React.Component<IWeeklyLineAndCandleChart> {

  render() {
    const {post, feedItems} = this.props;

    let lineAndCandleData: any | null = null;

    // get chart data
    const stepDatas: Array<any> = [];

    for (let s = 0; s < post.steps.length; s++) {
      if (this.props.stepId == post.steps[s]._id) {
        stepDatas.push(new StepData(post.steps[s], feedItems));

        // only allowing for a single data set at this point
        lineAndCandleData = new LineAndCandleData("Week", post.steps[s].shortName);
        break;
      }
    }

    if (null === lineAndCandleData) {
      return null;
    } else {
      // calculate the Average/Max/Min per week
      for (let i = 0; i < stepDatas.length; i++) {
        if (stepDatas[i].answers && stepDatas[i].answers.length > 0) {
          // create the weekly aggregates
          let weekAvgMinMax = new AvgMinMax(stepDatas[i].answers[0].answer);
          let weekKey = stepDatas[i].answers[0].date.isoWeek();

          for (let k = 1; k < stepDatas[i].answers.length; k++) {
            let newWeekKey = stepDatas[i].answers[k].date.isoWeek();
            if (weekKey != newWeekKey) {
              lineAndCandleData.addAvgMinMax(weekAvgMinMax);
              weekKey = newWeekKey;
              weekAvgMinMax = new AvgMinMax(stepDatas[i].answers[k].answer);
            } else {
              weekAvgMinMax.addData(stepDatas[i].answers[k].answer);
            }
          }
          lineAndCandleData.addAvgMinMax(weekAvgMinMax);
        }
      }

      return <LineAndCandleChart lineAndCandleData={lineAndCandleData}/>
    }
  }


}

export {WeeklyLineAndCandleChart};
